import { Col, Image, Layout, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useMediaPredicate } from "react-media-hook";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import Burger from "../../components/layouts/HomeLayout/Burger";
import Footer from "../../components/layouts/HomeLayout/Footer";
import { useScroll } from "../../utils/useScroll";
import UsadosBanner from "../../assets/img/Gamausados.webp";
import Logo from "../../assets/img/logo-mobility.webp";
import Base64Downloader from "common-base64-downloader-react";
import post1 from "../../assets/img/estado-financiero/2021-Estados-Financieros-30.06.2021.webp";
import post2 from "../../assets/img/estado-financiero/2021-Estados-Financieros-31.03.2021.webp";
import post3 from "../../assets/img/estado-financiero/2021-Estados-Financieros-Consolidados.webp";
import post4 from "../../assets/img/estado-financiero/EEFF-2018-para-pantalla.webp";
import post5 from "../../assets/img/estado-financiero/EEFF-2019-para-pantalla.webp";
import post6 from "../../assets/img/estado-financiero/EEFF-2020-para-pantalla.webp";
import post7 from "../../assets/img/estado-financiero/Memoria-anual-2019-para-pantalla.webp";
import post8 from "../../assets/img/estado-financiero/2022 EEFF.png";
import post9 from "../../assets/Portada web memoria.png"
import myPdf from "../../assets/Memoria Gama 2022.pdf"
import {
  pdfInformeEEFFconsolidadosal31122021GSFfirmadoEYdefpdf,
  pdfGAMAMEMORIAANUAL2021version08092022pdf,
  pdfEEFFGSFConsolidadoal31122020DEF,
  pdfEEFFGSFConsolidadoal31032021DEF,
  pdfEEFFGSFConsolidadoal30062021DEF,
  pdf20GSFEEFF122019,
  pdf20GSFEEFF122018,
  serviciosfinancieros2022,

} from "./utils/basePDF";
import { useDispatch, useSelector } from "react-redux";
import {
  getPostsHeaderContent,
  getPostsSectionContent,
} from "../../store/strapi/gamaleasing";
import { getGamaLeasingPostsContent } from "../../store/strapi/gamaleasing/thunks";

function Posts() {
  const biggerThan900 = useMediaPredicate("(min-width: 992px)");
  const [visible, setVisible] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGamaLeasingPostsContent());
  }, []);

  const postsHeader = useSelector(getPostsHeaderContent);
  const postsSection = useSelector(getPostsSectionContent);

  const { scrollDirection } = useScroll();
  const [isHome, setIsHome] = useState();

  const burguerData = [
    {
      title: "Sucursales",
      link: "/branches",
    },
    {
      title: "Nuestros servicios",
      link: "/mobility#services",
    },
    {
      title: "Quienes Somos",
      link: "/mobility#us",
    },
    { title: "Beneficios", link: "/mobility#benefits" },
    { title: "Publicaciones", link: "/mobility#posts" },
  ];

  useEffect(() => {
    if (window.location.pathname === "/posts") {
      setIsHome(false);
    } else {
      setIsHome(true);
    }
  }, [window.location.pathname]);

  const styles = {
    active: {
      // visibility: "visible",
      transition: "all 0.2s ease-in-out",
    },
    hidden: {
      // visibility: "hidden",
      transition: "all 0.2s ease-in-out",
      transform: biggerThan900 && "translateY(-2.3rem)",
    },
  };

  return (
    <div>
      <Layout>
        <section
          className="home-banner-container"
          id="header"
          style={{
            height: `80vh`,
          }}
        >
          <Row
            className="header-contain"
            style={{
              backgroundImage: `url(${
                postsHeader?.length === 0 || postsHeader === null
                  ? UsadosBanner
                  : postsHeader?.bannerImage?.data[0]?.attributes?.url
              })`,
            }}
          >
            <Col
              id="navbar"
              style={
                scrollDirection === "down" || !scrollDirection
                  ? styles.active
                  : styles.hidden
              }
            >
              <nav className="home-nav-container">
                <ul>
                  <li>
                    <a
                      target="_blank"
                      href={"https://gamamobility.cl/"}
                      rel="noreferrer"
                    >
                      GAMA MOBILITY
                    </a>
                  </li>
                  <li>
                    <Link
                      style={{
                        color:
                          window.location.pathname === "" ? "#FF3200" : "white",
                      }}
                      to={"/"}
                    >
                      GAMA LEASING
                    </Link>
                  </li>

                  <li>
                    <a href={"https://www.gamarent.cl/"}>RENT A CAR</a>
                  </li>
                  <li>
                    <a href={"https://www.tripp.cl/"}>TRIPP</a>
                  </li>
                  <li>
                    <Link to={"/usados"}>GAMA USADOS</Link>
                  </li>
                </ul>
              </nav>
              <header>
                <div className="home-nav-items">
                  <div className="home-nav-logo">
                    <Link to={"/mobility"}>
                      <Image
                        preview={false}
                        src={Logo}
                        style={{ width: "130px" }}
                      />
                    </Link>
                  </div>
                  <div className="group-nav-items">
                    <div
                      className="nav-container-buttons"
                      style={{
                        transition: "all ease-out 1s;",
                        opacity: `${visible ? "0" : "1"}`,
                        pointerEvents: `${visible ? "none" : "auto"}`,
                      }}
                    >
                      <Link to="/contact">
                        <Button
                          onClick={() => {}}
                          className="gama-outline talk-button"
                        >
                          Conversemos
                        </Button>
                      </Link>
                    </div>
                    <div className="container-menu">
                      {biggerThan900 ? (
                        <div className="container-navlinks">
                          {isHome ? (
                            <>
                              <a smooth href="/branches">
                                Sucursales
                              </a>
                              <a smooth href="#services">
                                Nuestros Servicios
                              </a>
                              <a smooth href="#us">
                                Quienes Somos
                              </a>
                              <a smooth href="#benefits">
                                Beneficios
                              </a>
                              <a smooth href="#posts">
                                Publicaciones
                              </a>
                            </>
                          ) : (
                            <>
                              <Link to="/branches">Sucursales</Link>
                              <Link to="/mobility">Nuestros Servicios</Link>
                              <Link to="/mobility#us">Quienes Somos</Link>
                              <Link to="/mobility#benefits">Beneficios</Link>
                              <Link to="/mobility#posts">Publicaciones</Link>
                            </>
                          )}
                        </div>
                      ) : (
                        <Burger
                          data={burguerData}
                          boton={false}
                          modal={visible}
                          onClose={() => {
                            setVisible(!visible);
                          }}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </header>
            </Col>
          </Row>
          <div className="banner-title-container">
            <h1
              style={{
                textAlign: "0",
                paddingLeft: "0",
                color: "#FF3200",
              }}
            >
              {postsHeader?.length === 0 || postsHeader === null
                ? "Publicaciones"
                : postsHeader?.title?.Title}
            </h1>
            <h3
              style={{
                textAlign: "",
                lineHeight: "42px",
                fontSize: "40px",
                fontWeight: "400",
                width: biggerThan900 ? "1200px" : "100%",
                // maxWidth: biggerThan900 ? "800px" : "",
                // marginRight: biggerThan900 ? "1120px" : "",
                paddingLeft: "0",
              }}
            >
              {postsHeader?.length === 0 || postsHeader === null
                ? "En Gama nos preocupamos de mantener informados a nuestros clientes. Ingresa e infórmate con nuestras publicaciones periódicas."
                : postsHeader?.title?.Detail}
            </h3>
          </div>
        </section>
      </Layout>
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
          margin: "50px 0px",
        }}
      >
        <Row
          style={{
            display: "flex",
            border: "1px solid lightgray",
            margin: "15px 15px",
          }}
        >
          <Col>
            <img style={{ height: "262px", width: "262px" }} src={post8} />
          </Col>

          <Col style={{ marginTop: "50px", marginLeft: "30px" }}>
            <Col
              style={{
                width: "200px",
                lineHeight: "20px",
                color: "#505d68",
                fontWeight: "700",
              }}
            >
              {postsHeader?.length === 0 || postsHeader === null
                ? "ESTADOS FINANCIEROS CONSOLIDADOS 2022"
                : postsSection[0]?.Card[0]?.Title}
            </Col>
            <Col>
              <Base64Downloader
                style={{
                  marginTop: "15px",
                  textDecoration: "underline",
                  color: "#F32000",
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                base64={serviciosfinancieros2022}
                downloadName="2022 EEFF GAMA Servicios Financieros y Filiales al 31-12-2022"
              >
                Descargar
              </Base64Downloader>
            </Col>
          </Col>
        </Row>

        <Row
          style={{
            display: "flex",
            border: "1px solid lightgray",
            margin: "15px 15px",
          }}
        >
          <Col>
            <img style={{ height: "262px", width: "262px" }} src={post9} />
          </Col>

          <Col style={{ marginTop: "50px", marginLeft: "30px" }}>
            <Col
              style={{
                width: "200px",
                lineHeight: "20px",
                color: "#505d68",
                fontWeight: "700",
              }}
            >
              MEMORIA ANUAL 2022
            </Col>
            <Col>
              <a
                style={{
                  marginTop: "15px",
                  textDecoration: "underline",
                  color: "#F32000",
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                href={myPdf}
                download="Memoria Anual 2022.pdf"
              >
                Descargar
              </a>
            </Col>
          </Col>
        </Row>

        <Row
          style={{
            display: "flex",
            border: "1px solid lightgray",
            margin: "15px 15px",
          }}
        >
          <Col>
            <img style={{ height: "262px", width: "262px" }} src={post6} />
          </Col>

          <Col style={{ marginTop: "50px", marginLeft: "30px" }}>
            <Col
              style={{
                width: "200px",
                lineHeight: "20px",
                color: "#505d68",
                fontWeight: "700",
              }}
            >
              {postsHeader?.length === 0 || postsHeader === null
                ? "ESTADOS FINANCIEROS CONSOLIDADOS 2020"
                : postsSection[0]?.Card[1]?.Title}
            </Col>
            <Col>
              <Base64Downloader
                style={{
                  marginTop: "15px",
                  textDecoration: "underline",
                  color: "#F32000",
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                base64={pdfEEFFGSFConsolidadoal31122020DEF}
                downloadName="EEFF-GSF-Consolidado-al-31.12.2020-DEF"
              >
                Descargar
              </Base64Downloader>
            </Col>
          </Col>
        </Row>
        <Row
          style={{
            display: "flex",
            border: "1px solid lightgray",
            margin: "15px 15px",
          }}
        >
          <Col>
            <img style={{ height: "262px", width: "262px" }} src={post1} />
          </Col>

          <Col style={{ marginTop: "50px", marginLeft: "30px" }}>
            <Col
              style={{
                width: "200px",
                lineHeight: "20px",
                color: "#505d68",
                fontWeight: "700",
              }}
            >
              {postsHeader?.length === 0 || postsHeader === null
                ? "ESTADOS FINANCIEROS INTERMEDIOS 30.06.2021"
                : postsSection[0]?.Card[2]?.Title}
            </Col>
            <Col>
              <Base64Downloader
                style={{
                  marginTop: "15px",
                  textDecoration: "underline",
                  color: "#F32000",
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                base64={pdfEEFFGSFConsolidadoal30062021DEF}
                downloadName="EEFF-GSF-Consolidado-al-30.06.2021-DEF"
              >
                Descargar
              </Base64Downloader>
            </Col>
          </Col>
        </Row>
        <Row
          style={{
            display: "flex",
            border: "1px solid lightgray",
            margin: "15px 15px",
          }}
        >
          <Col>
            <img style={{ height: "262px", width: "262px" }} src={post2} />
          </Col>

          <Col style={{ marginTop: "50px", marginLeft: "30px" }}>
            <Col
              style={{
                width: "200px",
                lineHeight: "20px",
                color: "#505d68",
                fontWeight: "700",
              }}
            >
              {postsHeader?.length === 0 || postsHeader === null
                ? "ESTADOS FINANCIEROS INTERMEDIOS 31.03.2021"
                : postsSection[0]?.Card[2]?.Title}
            </Col>
            <Col>
              <Base64Downloader
                style={{
                  marginTop: "15px",
                  textDecoration: "underline",
                  color: "#F32000",
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                base64={pdfEEFFGSFConsolidadoal31032021DEF}
                downloadName="EEFF-GSF-Consolidado-al-31.03.2021-DEF"
              >
                Descargar
              </Base64Downloader>
            </Col>
          </Col>
        </Row>
        <Row
          style={{
            display: "flex",
            border: "1px solid lightgray",
            margin: "15px 15px",
          }}
        >
          <Col>
            <img style={{ height: "262px", width: "262px" }} src={post4} />
          </Col>

          <Col style={{ marginTop: "50px", marginLeft: "30px" }}>
            <Col
              style={{
                width: "200px",
                lineHeight: "20px",
                color: "#505d68",
                fontWeight: "700",
              }}
            >
              {postsHeader?.length === 0 || postsHeader === null
                ? "ESTADOS FINANCIEROS CONSOLIDADOS 2018"
                : postsSection[0]?.Card[4]?.Title}
            </Col>
            <Col>
              <Base64Downloader
                style={{
                  marginTop: "15px",
                  textDecoration: "underline",
                  color: "#F32000",
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                base64={pdf20GSFEEFF122018}
                downloadName="20-GSF-EEFF-12_2018"
              >
                Descargar
              </Base64Downloader>
            </Col>
          </Col>
        </Row>
        <Row
          style={{
            display: "flex",
            border: "1px solid lightgray",
            margin: "15px 15px",
          }}
        >
          <Col>
            <img style={{ height: "262px", width: "262px" }} src={post5} />
          </Col>

          <Col style={{ marginTop: "50px", marginLeft: "30px" }}>
            <Col
              style={{
                width: "200px",
                lineHeight: "20px",
                color: "#505d68",
                fontWeight: "700",
              }}
            >
              {postsHeader?.length === 0 || postsHeader === null
                ? "ESTADOS FINANCIEROS CONSOLIDADOS 2019"
                : postsSection[0]?.Card[5]?.Title}
            </Col>
            <Col>
              <Base64Downloader
                style={{
                  marginTop: "15px",
                  textDecoration: "underline",
                  color: "#F32000",
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                base64={pdf20GSFEEFF122019}
                downloadName="20-GSF-EEFF-12_2019"
              >
                Descargar
              </Base64Downloader>
            </Col>
          </Col>
        </Row>
        <Row
          style={{
            display: "flex",
            border: "1px solid lightgray",
            margin: "15px 15px",
          }}
        >
          <Col>
            <img style={{ height: "262px", width: "262px" }} src={post3} />
          </Col>

          <Col style={{ marginTop: "50px", marginLeft: "30px" }}>
            <Col
              style={{
                width: "200px",
                lineHeight: "20px",
                color: "#505d68",
                fontWeight: "700",
              }}
            >
              {postsHeader?.length === 0 || postsHeader === null
                ? "ESTADOS FINANCIEROS CONSOLIDADOS 31.12.2021"
                : postsSection[0]?.Card[6]?.Title}
            </Col>
            <Col>
              <Base64Downloader
                style={{
                  marginTop: "15px",
                  textDecoration: "underline",
                  color: "#F32000",
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                base64={pdfInformeEEFFconsolidadosal31122021GSFfirmadoEYdefpdf}
                downloadName="Informe-EEFF-consolidados-al-31.12.2021-GSF-firmado-EY-def"
              >
                Descargar
              </Base64Downloader>
            </Col>
          </Col>
        </Row>
        <Row
          style={{
            display: "flex",
            border: "1px solid lightgray",
            margin: "15px 15px",
          }}
        >
          <Col>
            <img style={{ height: "262px", width: "262px" }} src={post7} />
          </Col>

          <Col style={{ marginTop: "50px", marginLeft: "30px" }}>
            <Col
              style={{
                width: "200px",
                lineHeight: "20px",
                color: "#505d68",
                fontWeight: "700",
              }}
            >
              {postsHeader?.length === 0 || postsHeader === null
                ? "Memoria Anual 2021"
                : postsSection[0]?.Card[7]?.Title}
            </Col>
            <Col>
              <Base64Downloader
                style={{
                  marginTop: "15px",
                  textDecoration: "underline",
                  color: "#F32000",
                  backgroundColor: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
                base64={pdfGAMAMEMORIAANUAL2021version08092022pdf}
                downloadName="GAMA-MEMORIA ANUAL-2021-version 08092022"
              >
                Descargar
              </Base64Downloader>
            </Col>
          </Col>
        </Row>
      </Row>
      
      <Footer logo={Logo} />
    </div>
  );
}

export default Posts;
